import { takeEvery, put, select } from 'redux-saga/effects'
import { CHAT_OPEN, CHAT_CLOSE, CHAT_TOGGLE } from 'store/actions/Chat/types'
import { chatStateSelector } from 'store/actions/Chat/selectors'

/*function* openChatSaga() {
  console.log('Chat opened via saga')
  // Дополнительная логика при открытии чата
  // например, отправка аналитики, логирование и т.д.

  // Можно добавить API вызовы для уведомления бэкенда
  // yield call(api.trackEvent, 'chat_opened')

  // НЕ НУЖНО ВЫЗЫВАТЬ put(openChat()) здесь - это создает рекурсию!
  // Reducer сам обработает CHAT_OPEN действие
}

function* closeChatSaga() {
  console.log('Chat closed via saga')
  // Дополнительная логика при закрытии чата

  // Можно очистить непрочитанные сообщения или сохранить состояние
  // yield call(api.trackEvent, 'chat_closed')

  // НЕ НУЖНО ВЫЗЫВАТЬ put(closeChat()) здесь - это создает рекурсию!
  // Reducer сам обработает CHAT_CLOSE действие
}*/

function* toggleChatSaga() {
  // Получаем текущее состояние чата
  const isCurrentlyOpen = yield select(chatStateSelector)

  if (isCurrentlyOpen) {
    // Если чат открыт, закрываем его
    yield put({ type: CHAT_CLOSE })
  } else {
    // Если чат закрыт, открываем его
    yield put({ type: CHAT_OPEN })
  }
}

export function* chatSaga() {
/*  yield takeEvery(CHAT_OPEN, openChatSaga)
  yield takeEvery(CHAT_CLOSE, closeChatSaga)*/
  yield takeEvery(CHAT_TOGGLE, toggleChatSaga)
}